import { Component, EventEmitter, OnChanges, Input, Output, SimpleChanges } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

export interface SlaFilterCard {
    id: string;
    label: string;
    count: number;
    selected: boolean;
    statusLabel: string;
}

@Component({
    selector: 'app-dashboard-sla-due-date-filters',
    templateUrl: './dashboard-sla-due-date-filters.component.html',
    styleUrl: './dashboard-sla-due-date-filters.component.scss',
    imports: [ MatCardModule, MatCheckboxModule, MatIconModule, FormsModule ],
})
export class DashboardSlaDueDateFilters implements OnChanges {
    @Input() slaDueDateCounts: { dueTomorrow: number; dueToday: number; pastDue: number; };
    @Input() totalItems: number;
    @Input() isDisabled: boolean = false;
    @Input() context: 'cases' | 'tasks' = 'cases';
    @Input() selectedIds: string[] = [];
    @Output() valueEmitted = new EventEmitter<string>();
    
    slaFilterCards: SlaFilterCard[] = [
        {
            id: 'pastDue',
            label: 'Past Due',
            count: 0,
            selected: false,
            statusLabel: 'Out of SLA'
        },
        {
            id: 'dueToday',
            label: 'Due Today',
            count: 0,
            selected: false,
            statusLabel: 'At Risk'
        },
        {
            id: 'dueTomorrow',
            label: 'Due Tomorrow',
            count: 0,
            selected: false,
            statusLabel: 'Upcoming'
        }
    ];

    getPercentage(count: number): number {
        return this.totalItems > 0 ? Math.round((count / this.totalItems) * 100) : 0;
    }

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.slaDueDateCounts) {
            this.slaFilterCards.forEach(card => {
                card.count = this.slaDueDateCounts[card.id] || 0;
            });
        }
        if (changes['selectedIds']) {
            const selected = new Set(this.selectedIds ?? []);
            this.slaFilterCards.forEach(card => card.selected = selected.has(card.id));
        }
        const pastDueCard = this.slaFilterCards.find(c => c.id === 'pastDue');
        if (pastDueCard) {
            pastDueCard.statusLabel = this.context === 'tasks' ? 'Past Follow Up' : 'Out of SLA';
        }
    }

    onCardSelectionChange(card: SlaFilterCard) {
        if (this.isDisabled) return;
        card.selected = !card.selected;
        const selectedIds = this.slaFilterCards
            .filter(c => c.selected)
            .map(c => c.id)
            .join(',');
        this.valueEmitted.emit(selectedIds);
    }

    clearSelections(): void {
        this.slaFilterCards.forEach(card => card.selected = false);
    }

}
